module.exports = __webpack_public_path__ + "static/media/GoogleLogo.37b78e51.svg";